import { render, staticRenderFns } from "./BFormDialogV2.vue?vue&type=template&id=5bf4f8d6&scoped=true&"
import script from "./BFormDialogV2.vue?vue&type=script&lang=js&"
export * from "./BFormDialogV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf4f8d6",
  null
  
)

export default component.exports